import React, { useState, useRef, useEffect } from 'react';
import { Button, Input, Space, Popconfirm } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useRouteMatch } from 'react-router-dom';
import Highlighter from 'react-highlight-words';
import { SearchOutlined } from '@ant-design/icons';
import notification from '@iso/components/Notification';
import HelperText from '@iso/components/utility/helper-text';
import LayoutWrapper from '@iso/components/utility/layoutWrapper';
import PageTitleBar from '@iso/components/utility/PageTitleBar';
import FormWindow from '@iso/containers/Dashboard/FormWindow';
import EditAdictionConstant from './EditAdictionConstant';
import IntlMessages from '@iso/components/utility/intlMessages';
import Scrollbars from '@iso/components/utility/customScrollBar';
import adictionConstantsActions from '@iso/redux/adictionConstant/actions';
import Loader from '@iso/components/utility/loader';
import { b64_to_utf8, formatStringToFloatMoney, testEmpty, textLimit } from '@iso/lib/helpers/utility';

import CardWrapper, { Box, StatusTag } from './allList.style';
import TableWrapper from '../../Tables/AntTables/AntTables.styles';

const { initData, deleteAdictionConstants } = adictionConstantsActions;

export default function AdictionConstants() {
	const ses = sessionStorage.getItem("permissions");
	const arraySplit = b64_to_utf8(ses).split(",");
  const [selected, setSelected] = useState([]);
  const [editingId, setEditingId] = useState(null);
  const { initialAdictionConstants, adictionConstants } = useSelector((state) => state.AdictionConstant);
  const dispatch = useDispatch();
  const match = useRouteMatch();

  const [searchText, setSearchText] = useState('');
  const [searchedColumn, setSearchedColumn] = useState('');
  const searchInput = useRef(null);
  const handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    setSearchText(selectedKeys[0]);
    setSearchedColumn(dataIndex);
  };
  const handleReset = (clearFilters) => {
    clearFilters();
    setSearchText('');
  };

  const getColumnSearchProps = (dataIndex, collum) => ({
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters, close }) => (
      <div
        style={{
          padding: 8,
        }}
        onKeyDown={(e) => e.stopPropagation()}
      >
        <Input
          ref={searchInput}
          placeholder={`Buscar ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={(e) => setSelectedKeys(e.target.value ? [e.target.value] : [])}
          onPressEnter={() => handleSearch(selectedKeys, confirm, collum)}
          style={{
            marginBottom: 8,
            display: 'block',
          }}
        />
        <Space>
          <Button
            type="primary"
            onClick={() => handleSearch(selectedKeys, confirm, collum)}
            icon={<SearchOutlined />}
            size="small"
            style={{
              width: 90,
            }}
          >
            Buscar
          </Button>
          <Button
            onClick={() => clearFilters && handleReset(clearFilters)}
            size="small"
            style={{
              width: 90,
            }}
          >
            Limpar
          </Button>
          <Button
            type="link"
            size="small"
            onClick={() => {
              close();
            }}
          >
            Fechar
          </Button>
        </Space>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined
        title={"Pesquisar pelo "+dataIndex+" da Constante Adicional"}
        style={{
          color: '#000000',
        }}
      />
    ),
    onFilter: (value, record) => {
        return record[collum]?.toString().toLowerCase().includes(value.toLowerCase())
    },
    onFilterDropdownOpenChange: (visible) => {
      if (visible) {
        setTimeout(() => searchInput.current?.select(), 100);
      }
    },
    render: (text) =>
      searchedColumn === collum ? (
        <Highlighter
          highlightStyle={{
            backgroundColor: '#ffc069',
            padding: 0,
          }}
          searchWords={[searchText]}
          autoEscape
          textToHighlight={text ? text.toString() : ''}
        />
      ) : (
        text
      ),
  });

  useEffect(() => {
    if (!initialAdictionConstants) {
      dispatch(initData());
    }
  }, [dispatch, initialAdictionConstants]);

  const columns = [
    {
      title: 'Nome',
      dataIndex: 'name',
      key: 'name',
      width: '15%',
      render: (text) => <span>{text}</span>,
      ...getColumnSearchProps('Nome', 'name')
    },
    {
      title: 'Identificador',
      dataIndex: 'identificator',
      key: 'identificator',
      width: '15%',
      render: (text) => <span>{text}</span>
    },
    {
      title: 'Valor',
      dataIndex: 'value',
      key: 'value',
      width: '15%',
      render: (text, all) => {
        if(all.type === "Decimal"){
          return (<span>R$ {formatStringToFloatMoney(text)}</span>)
        } else if(all.type === "Porcentagem"){
          return (<span>{(text)}%</span>)
        }
        else {
          return (<span>{(text)}</span>)
        }
      }
    },
    {
      title: 'Fórmula valor',
      dataIndex: 'formula_value',
      key: 'formula_value',
      width: '15%',
      render: (text) => <span>{(testEmpty(text, '') === '') ? 'Não' : textLimit(text, 20)}</span>
    },
    {
      title: 'Calculado',
      dataIndex: 'calculated',
      key: 'calculated',
      width: '10%',
      render: (text) => <span>{(text === 'Start') ? 'Início' : ((text === 'Middle') ? 'Meio' : 'Final')}</span>
    },
    {
      title: 'Status',
      dataIndex: 'situation',
      key: 'situation',
      width: '15%',
      render: (text) => {
        let className;
        if (text === 'ativo' || text === 'Ativo' || text === 'ATIVO') {
          className = 'ativo';
        } else if ( text === 'inativo' || text === 'Inativo' || text === 'INATIVO' ) {
          className = 'inativo';
        }
        return <StatusTag className={className}>{text}</StatusTag>;
      },
    },
    {
      title: '',
      dataIndex: 'view',
      rowKey: 'view',
      width: '10%',
      render: (_, adictionConstant) => (
        <div className="isoAdictionConstantBtnView">
          {arraySplit.includes('Constante_Adicional_editar') || arraySplit.includes('all')  ? 
            <a href={`${match.path}/${adictionConstant._id}`} onClick={(event) => { event.preventDefault(); setEditingId(adictionConstant._id); }}>
              <Button color="primary" className="viewBtn">
                Editar
              </Button>
            </a>
          : ''}
          {arraySplit.includes('Constante_Adicional_excluir') || arraySplit.includes('all')  ? 
            <Popconfirm title="Deseja realmente deletar?" onConfirm={() => {
                const index = adictionConstants.map(inv => inv._id).indexOf(adictionConstant._id);
                dispatch(deleteAdictionConstants(adictionConstants[index]._id));
                notification('success', '1 constânte deletado');
            }}>
              <Button className="dltBtn" onClick={() => { }}>
                <i className="ion-android-delete" />
              </Button>
            </Popconfirm>
          : ''}
        </div>
      ),
    },
  ];


  const rowSelection = {
    hideDefaultSelections: true,
    selectedRowKeys: selected,
    onChange: (selected) => setSelected(selected),
    selections: [
      {
        rowKey: 'all-data',
        text: 'Selecionar todos',
        onSelect: () => setSelected(adictionConstants.map((person) => person._id)),
      },
      {
        rowKey: 'no-data',
        text: 'Desselecionar',
        onSelect: () => setSelected([]),
      },
    ],
    onSelection: (selected) => setSelected(selected),
  };

  return (
    <LayoutWrapper>
      <PageTitleBar title="Constânte Adicional" />      <Box style={{ border: 'none', boxShadow: 'none' }}>
        <div className="isoTableBtn">
          <Link to={`${match.path}/0`}>
            <Button type="primary" className="mateAddBtn">
              Adicionar
            </Button>
          </Link>
        </div>
        {!initialAdictionConstants ? (
          <Loader />
        ) : (
        <CardWrapper>
          {adictionConstants !== undefined && adictionConstants.length === 0 ? (
            <HelperText text="Sem Constânte Adicionais" />
          ) : (
            <div className="isoTable">
              <div
                style={{ width: '100%' }}
              >
                <TableWrapper
                  rowKey={"_id"}
                  rowSelection={rowSelection}
                  dataSource={adictionConstants}
                  columns={columns}
                  pagination={{ defaultPageSize: 20, showSizeChanger: true, pageSizeOptions: ['10', '20', '50', '100'] }}
                  className="listTable"
                />
              </div>
            </div>
          )}
        </CardWrapper>
        )}
      </Box>
          <FormWindow
        open={editingId !== null}
        title={editingId === '0' ? 'Cadastro de Adicional Constante' : 'Edicao de Adicional Constante'}
        onClose={() => setEditingId(null)}
      >
        {({ footerEl }) =>
          editingId !== null ? (
            <EditAdictionConstant
              adictionConstantId={editingId}
              inModal
              footerEl={footerEl}
              onCancel={() => setEditingId(null)}
              onSaved={() => {
                setEditingId(null);
                dispatch(initData());
              }}
            />
          ) : null
        }
      </FormWindow>
    </LayoutWrapper>
  );
}
